<!-- <p>sap-case-detail works!</p> -->
<ng-template #PageLoadingTemplate>
    <app-loading-template DisplayText="Please wait while we load Case information" />
</ng-template>

<div class="main-events-div" *ngIf="cmmsCase && asset && timelineItems.length > 0 else PageLoadingTemplate">
    <div>
        <div class="title-div alignRow">
            @if(asset && cmmsCase){
            <span style="font-size: large; font-weight: bolder;">Case Details: {{asset.Name}} -
                {{cmmsCase.Cause}}</span>
            }
            <span class="me-auto"></span>
            <button mat-raised-button (click)="back()" style="margin: 0.25em; margin-bottom: 0.5em;"
                class="app-icon--back">
                <mat-icon />
                <span>Back</span>
            </button>
        </div>
    </div>
    <div class="button-div">
        @if (asset) {
        <button *ngIf="asset" mat-raised-button color="primary" (click)="goToAsset()" class="app-icon--goto">
            <span>Go To Asset</span>
            <mat-icon />
        </button>
        }
        @if (cmmsCase.TriggerID) {
        <button mat-raised-button color="primary" (click)="OpenTrigger(cmmsCase)">
            <span matTooltip="View Triggering Event">View Event</span>
            <mat-icon>visibility_on</mat-icon>
        </button>
        } @else {
        <span>Manually created by {{cmmsCase.UserIDString}} </span>
        }
    </div>
    <br>
    @if(asset && cmmsCase){
    <div class="asset-container">
        <div class="asset-image alignColumn alignRow">
            <img (click)="viewImage(imagePathAssets() + asset.AssetID + '?' + asset.Modified)"
                src="{{imagePathAssets()}}{{asset.AssetID}}?{{asset.Modified}}" alt="{{asset.Name}}"
                onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'" />
        </div>
        <div class="case-asset-details">
            <span style="font-weight: bold;">Case ID:</span>
            <span>{{ cmmsCase.Id }}</span>
            <span style="font-weight: bold;">Location:</span>
            <span>{{ cmmsCase.FL }}</span>
            <span style="font-weight: bold;">Asset:</span>
            <span>{{ asset.Name }} - {{ asset.Description }}</span>
            @if (asset.EquipmentCode) {
            <span style="font-weight: bold;">EQ Code:</span>
            <span>{{ asset.EquipmentCode }}</span>
            }
            @if (cmmsCase.Cause) {
            <span style="font-weight: bold;">Cause Type:</span>
            <span>{{ cmmsCase.Cause }}</span>
            }
            <span style="font-weight: bold;">Trigger Type:</span>
            <span>{{ getTriggerTypeFromValue(cmmsCase.TriggerType) }}</span>
        </div>
    </div>
    }
    <br>
    @if (timelineItems && timelineItems.length > 0 && displayTimeline) {
    <ejs-accordion id="timeline-accordion" *ngIf="displayTimeline"  style="border-radius: var(--default-border-radius);">
        <e-accordionitems>
            <e-accordionitem expanded="true">
                <ng-template #header>
                    <span>Timeline</span>
                </ng-template>
                <ng-template #content>
                    <div>
                        <ng-container *ngTemplateOutlet="timeline"></ng-container>
                    </div>
                </ng-template>
            </e-accordionitem>
        </e-accordionitems>
    </ejs-accordion>
    }
</div>

<ng-template #timeline>
    @if (timelineItems && timelineItems.length > 0) {
    <div class="timeline-div alignColumn">
        <ejs-timeline orientation="Vertical" alignment="Before" [template]="customTemplate" cssClass="custom-timeline">
            <e-items>
                @for (item of timelineItems; track $index) {
                <e-item [dotCss]="item.dotCss" [content]="item.content" [oppositeContent]="item.oppositeContent" />
                }
            </e-items>
            <ng-template #customTemplate let-data="">
                @let CaseDataItem = data.item;
                <div class='template-container'>
                    <div class="progress-line" [ngClass]="{'last': checkNotLast(data)}">
                        <div class="indicator alignRow alignColumn">
                            <mat-icon style="z-index: 1001;">{{dotCssIcon[CaseDataItem.dotCss]}}</mat-icon>
                        </div>
                    </div>
                    <div class="timeline-content">
                        @let timelineContent = buildObject(CaseDataItem.content, CaseDataItem.dotCss);
                        @if (timelineContent) {
                        <div class="content-container alignRow">
                            @switch (CaseDataItem.dotCss) {
                            @case ('1') { <!-- Case Created -->
                            <div class="timeline-element">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(CaseDataItem)">
                                    <span>Case Created</span>
                                    <span class="me-auto"></span>
                                    <span>{{data.item.oppositeContent}}</span>
                                </div>
                                <br>
                                <div class="timeline-item timeline-item--caseopened">
                                    <span class="col1-row1 timeline-item-title">Id:</span>
                                    <span class="col1-row2 timeline-item-title">Trigger:</span>
                                    <span class="col3-row1 timeline-item-title">Description:</span>
                                    <span class="col2-row1">{{timelineContent.Id}}</span>
                                    <span class="col2-row2">{{timelineContent.Trigger}}</span>
                                    <span class="col3-row2">{{timelineContent.Description}}</span>
                                </div>
                            </div>
                            }
                            @case ('2') { <!-- Case Acknowledged -->
                            <div class="timeline-element">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(CaseDataItem)">
                                    <span>Case Acknowledged</span>
                                    <span class="me-auto"></span>
                                    <span>{{CaseDataItem.oppositeContent}}</span>
                                </div>
                            </div>
                            }
                            @case ('3') { <!-- Work Event -->
                            <div class="timeline-element">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(CaseDataItem)">
                                    <span>Work Event</span>
                                    <span class="me-auto"></span>
                                    <span>{{CaseDataItem.oppositeContent}}</span>
                                </div>
                                <br>
                                <div class="timeline-item timeline-item--workevent">
                                    <span class="col1-row1 timeline-item-title">Id:</span>
                                    <span class="col1-row2 timeline-item-title">Message:</span>
                                    <span class="col3-row1 timeline-item-title">Activity:</span>
                                    <span class="col4-row1 timeline-item-title">Time Spent:</span>
                                    <span class="col2-row1 ">{{timelineContent.Id}}</span>
                                    <span class="col2-row2 ">{{timelineContent.Message}}</span>
                                    <span class="col3-row3 ">{{timelineContent.WorkActivity}}</span>
                                    <span class="col4-row3 ">{{timelineContent.TimeSpent}}</span>
                                </div>
                            </div>
                            }
                            @case ('4') { <!-- Case Closed -->
                            <div class="timeline-element">
                                <div class="timeline-title alignRow" (click)="goToTimelineItem(CaseDataItem)">
                                    <span>Case Closed</span>
                                    <span class="toolbar-spacer"></span>
                                    <span>{{CaseDataItem.oppositeContent}}</span>
                                </div>
                                <br>
                                <div class="timeline-item timeline-item--caseclosed">
                                    <span class="col1-row1 timeline-item-title">Id</span>
                                    <span class="col1-row2 timeline-item-title">Reasonable:</span>
                                    <span class="col3-row1 timeline-item-title">Comments</span>
                                    <span class="col2-row1 ">{{timelineContent.Id}}</span>
                                    <span class="col2-row2 ">{{timelineContent.ReasonableToOpen ? 'Yes' :
                                        'No'}}</span>
                                    <span class="col3-row2 ">{{timelineContent.OtherComments}}</span>

                                </div>
                            </div>
                            }
                            }
                        </div>
                        }
                    </div>
                </div>
            </ng-template>
        </ejs-timeline>
    </div>
    }
</ng-template>